import * as HLF from "html-living-framework";

export function spritesheet(name: string) {
    return new HLF.AssetMapData(name, HLF.AssetType.TEXTURE_ATLAS);
}

export function texture(name: string): PIXI.Texture | undefined {
    if (!name) {
        return undefined;
    }
    const cache = PIXI.utils.TextureCache;
    return cache[name] || cache[name + ".png"] || cache[name.replace(/(@\dx)?\.(png|jpg|jpeg)$/i, "")];
}

export function encodeHtmlEntities(str: string) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

export function decodeHtmlEntities(str: string) {
    return str
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"');
}
